module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAIAAACMMcMmAAAANElEQVRIx2P8u1OYgcaAcdSOkWfHsnkqNLeDIctl1I5RO6huR72dKc3tOKiuO2rHqB3UBgBSBxe3gsmmOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/lt.png
// module id = 873
// module chunks = 0